import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import GridContainer from "#app/components/layout/GridContainer/GridContainer";
import CabinetLayout from "#app/pages/router/CabinetLayout";
import {
    ApplicationPage,
    Cabinet,
    CalendarFilter,
    CalendarPage,
    ClientsPage,
    Common,
    EventTranscription,
    FunnelPage,
    Hierarchy,
    Learn,
    LearnAton,
    TestPage,
} from "./LazyLoadedPages";
import UnexpectedError from "#app/interface/error/UnexpectedError";
import ListSkeleton from "#app/components/common/ListSkeleton";

interface CabinetRoutesProps {
    logout: () => void;
    [key: string]: unknown;
}

const CabinetRoutes: React.FC<CabinetRoutesProps> = ({ ...props }) => (
    <Routes>
        <Route element={<CabinetLayout />}>
            <Route path="/error" element={<UnexpectedError />} />
            <Route
                path="/calendar"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <GridContainer
                            style={{
                                gridTemplateColumns: "auto 300px",
                                gridTemplateRows: "1fr",
                                gridGap: "0",
                            }}
                        >
                            <CalendarPage
                                style={{ gridColumn: "1", gridRowStart: "1", gridRowEnd: "2" }}
                                {...props}
                            />
                            <CalendarFilter
                                style={{ gridColumn: "2", gridRowStart: "1", gridRowEnd: "1" }}
                                {...props}
                            />
                        </GridContainer>
                    </Suspense>
                }
            />
            <Route
                path="/application"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <ApplicationPage {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/clients"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <ClientsPage {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/config"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <Common {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/funnel"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <FunnelPage {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/hierarchy"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <Hierarchy {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/learn"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <Learn {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/learn/aton"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <LearnAton {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/swanny"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <EventTranscription {...props} />
                    </Suspense>
                }
            />
            <Route
                path="/test"
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <TestPage {...props} />
                    </Suspense>
                }
            />
            <Route
                path=""
                element={
                    <Suspense fallback={<ListSkeleton count={12} />}>
                        <Cabinet {...props} />
                    </Suspense>
                }
            />
        </Route>
    </Routes>
);

export default CabinetRoutes;
